import { store } from "../store.js";
import { parsers } from "./parsers.js";

class DataParser {
  constructor() {
    parsers.addType("data", this._applyData.bind(this));
  }

  _applyData(data) {
    store.set("data", data, true);
  }
}

const dataParser = new DataParser();
export { DataParser, dataParser };
